import { Routes } from '@angular/router';
import { BuildingShellComponent } from './forms/building-shell.component';
import { FormDashboardComponent } from './forms/dashboard/form-dashboard.component';
import { FormsHostComponent } from './forms/forms-host.component';
import { MissingBuildingComponent } from './forms/missing-building.component';

export const routes: Routes = [
  { path: '', redirectTo: 'missing-building', pathMatch: 'full' },
  { path: 'building', redirectTo: 'missing-building', pathMatch: 'full' },
  { path: 'missing-building', component: MissingBuildingComponent },
  {
    path: 'building/:buildingId',
    component: BuildingShellComponent,
    children: [
      { path: '', redirectTo: 'form-dashboard', pathMatch: 'full' },
      { path: 'form-dashboard', component: FormDashboardComponent },
      { path: ':formName', component: FormsHostComponent }
    ]
  },
  { path: '**', redirectTo: 'missing-building' }
];
